// extracted by mini-css-extract-plugin
export default {"card":"TypeCard_card__dGEwk","shadowEffect":"TypeCard_shadowEffect__BLtHZ","image":"TypeCard_image__rARzC","label":"TypeCard_label__9hXjr","bar":"TypeCard_bar__AcOh+"};